import { GetAccountResponse } from '@sxm-de/dev-kits/microservices-sdk/types';

export type GetAccountByEmailFn = (payload: {
    email: string;
}) => Promise<GetAccountResponse>;

export function initGetAccountByEmailFn({
    baseUrl,
}: {
    baseUrl: string;
}): GetAccountByEmailFn {
    return async ({ email }) => {
        const url = `${baseUrl}/identity/customer/email`;
        const headers = {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json',
        };
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                email,
            }),
        });
        if (!response.ok) return Promise.reject(await response.json());
        const { data } = await response.json();
        return data;
    };
}
